export default function Privacy() {
    return (
        <>
            <h1>Privacy policy</h1>
        </>
    );
}